<template>
  <div>
    <router-view v-if="linkcode"></router-view>
    <page-not-found v-else></page-not-found>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    let linkcode = new URL(window.location.href)
    let linkcodes = linkcode.searchParams.get('linkcode').split('?')
    linkcode = linkcodes[0]
    if (linkcode) {
      this.$store.dispatch('getBill', linkcode).then(() => {
        if (
          Object.keys(this.$store.state.billData).length === 0 &&
          this.$store.state.billData.constructor === Object
        ) {
          this.$store.commit('UPDATE_LINKCODE', null)
        }
      })
    } else {
      this.$store.commit('UPDATE_LINKCODE', null)
    }
  },
  computed: {
    linkcode() {
      return this.$store.state.linkcode
    },
  },
}
</script>

<style>
:root {
  --main-color: #002d72;
  --font-gray: #303131;
}

button {
  display: block;
  margin: 10px auto 10px auto;
  width: 40%;
  height: 70px;
  border-radius: 50px;
  border: none;
  background-color: #002d72;
  color: white;
  font-family: 'Kanit';
  font-weight: 400;
  font-size: 30px;
}
.deactive {
  background-color: #d4d4d4 !important;
}
.text_deactive {
  color: #d4d4d4 !important;
}
.text_deactive .titillium-r {
  color: #d4d4d4 !important;
}

@media only screen and (max-width: 1200px) {
  button {
    height: 66px;
    font-size: 30px;
    width: 60%;
  }
}
@media only screen and (max-width: 576px) {
}
@media only screen and (max-width: 414px) {
}
</style>
